import React, { useState } from "react";
import styled from "styled-components";

const StyledElement = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  width: 100%;

& .image-container {
    display: flex;
    position: absolute;
    top: 309px;
    left: 161px;
    width: 800px;
    height: 800px;
}  

& .text-container {
    display: flex;
   flex-direction: column;
    position: absolute;
    top: 333px;
    left: 973px;
    width: 390px;
    gap: 40px;
}

& .text-image {
    width: 390px;
    height: 92px;
    cursor: pointer;
}

& .overlay-content {
    position: relative;
    // margin: 20px auto;
    // padding: 20px;
    z-index: 1;
    display: flex;
    flex-direction: column;
}

`;


export const BhHomepage5 = () => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0); // 상태를 1로 초기화

    // 이미지 URL을 동적으로 설정
    const imageUrls = Array.from({ length: 7 }, (_, index) => `/image/5page_${index}.png`);
    // 텍스트 이미지 URL 설정
    const textImageUrls = Array.from({ length: 6 }, (_, index) => `/image/5page_text_${index + 1}_up.png`);
    const selectedTextImageUrls = Array.from({ length: 6 }, (_, index) => `/image/5page_text_${index + 1}_dn.png`);

    // 이미지 클릭 핸들러
    const handleImageClick = (index) => {
        console.log('select index: ', index);
        setCurrentImageIndex(index);
    };

    return (
        <StyledElement>
            <img className="background-image" alt="background-image" src="/image/5page.png" />
            <div className="image-container">
                {imageUrls.map((url, index) => (
                    <img
                        key={index}
                        src={url}
                        alt={`image-${index}`}
                        style={{
                            display: currentImageIndex === index ? 'block' : 'none' // 현재 인덱스와 일치할 때만 이미지 표시
                        }}
                    />
                ))}
            </div>
            <div className="text-container">
                {textImageUrls.map((url, index) => {
                    // 현재 index와 currentImageIndex에 따라 src URL을 결정
                    const src = currentImageIndex === 0
                        ? url
                        : (currentImageIndex === index + 1 ? selectedTextImageUrls[index] : url);

                    // 로그에 src 값 출력
                    console.log(`Image ${index + 1} src: ${src}`);

                    return (
                        <img
                            key={index}
                            src={src}
                            alt={`text-image-${index}`}
                            className={`text-image ${currentImageIndex === index + 1 ? 'selected' : ''}`}
                            onClick={() => handleImageClick(index + 1)} // 클릭 시 인덱스 업데이트
                        />
                    );
                })}
            </div>
        </StyledElement>
    );
};
